<div class="{{cardClass}} form-card">
  <ng-content></ng-content>
</div>
